import React, { useContext, useEffect, useRef, useState } from "react";
import "./TaskMemberDropdown.css";
import { useLanguage } from "../../../../LanguageProvider";
import Chip from "../../../../components/Chip/Chip";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import { GeneralContext } from "../../../../GeneralProvider";


export default function TaskMemberDropdown({ users, inTaskUsers, task }) {
    const { handleAddMemberToTask, handleRemoveMemberFromTask } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const [addedUsers, setAddedUsers] = useState(inTaskUsers || []);
    const isFirstLoad = useRef(true);

    const dropdownOptions = users
        ?.filter((user) => !addedUsers?.some((u) => u.userID === user.userID))
        .map((user) => ({
            value: user.userID,
            label: `${user.name} ${user.lastname}`,
        }));

    const handleAddUser = (userToAdd) => {
        if (userToAdd && !addedUsers?.some((user) => user.userID === userToAdd.userID)) {
            setAddedUsers([...addedUsers, userToAdd]);
            handleAddMemberToTask([userToAdd.userID], task.taskId)
        }
    };

    const handleRemoveUser = (userID) => {
        setAddedUsers(
            addedUsers.filter(
                (user) => user.userID !== userID
            )
        );

        handleRemoveMemberFromTask(userID, task.taskId)
    };

    useEffect(() => {
        if (isFirstLoad.current && inTaskUsers && inTaskUsers.length > 0) {
            setAddedUsers(inTaskUsers);
            isFirstLoad.current = false;
        }
    }, [inTaskUsers, task]);


    return (
        <div className="add-user-panel">
            <div className="add-user">
                <Dropdown
                    style={{ marginRight: "2px", width: "100%" }}
                    options={dropdownOptions}
                    placeholder={getTranslation("selectFromList")}
                    onChange={(e) => {
                        const selected = users.find(
                            (user) => user.userID === e.target.value
                        );
                        handleAddUser(selected)
                    }}
                    value={""}
                    isDisabled={!users || users.length === 0}
                />
            </div>

            <div className="collaborators-chips">
                {addedUsers?.map((user, index) => (
                    <Chip
                        onDeleteClicked={() =>
                            handleRemoveUser(user.userID)
                        }
                        label={`${user.name} ${user.lastname}`}
                        key={index}
                    />
                ))}
            </div>

        </div>
    );
}